<template>
  <b-card class="card">
    <slot></slot>
  </b-card>
</template>

<script>
export default {
  name: 'Card',
};
</script>
<style scoped>
.card {
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(217, 217, 217, 0.5);
}
</style>
